import { getQueryParams } from "@/utils/httpRequest";
import { lenderService } from "@/modules/contacts/features/lender/store/services/lender-service";
import { LENDER_LOANS_HEATMAP_SERVICE_TAG } from "@/modules/contacts/features/lender/utils/lender-service-tags";
import { LIST_SERVICE_TAG } from "@/shared/store/service/commonServiceTags";

const getLenderLoansHeatMap = lenderService.injectEndpoints({
  endpoints: builder => ({
    getLenderLoansHeatMap: builder.infiniteQuery({
      query: (queryArg, api = {}) => {
        const actualArgs = queryArg.queryArg || queryArg;
        const pageParam = queryArg.pageParam || api.pageParam || 1;
        const { lenderId, size = 25 } = actualArgs;
        const queryString = getQueryParams({ page: pageParam, size });
        return `lenders/${lenderId}/heatmap?${queryString}`;
      },
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages, lastPageParam) => {
          if (!lastPage) return undefined;

          const currentPage = lastPageParam || lastPage.page || 1;
          const { totalPages } = lastPage;

          if (!totalPages) return undefined;
          if (currentPage >= totalPages || !lastPage.records?.length) return undefined;

          return currentPage + 1;
        },
      },
      providesTags: result =>
        result
          ? [
              ...(result.pages?.flatMap(
                page =>
                  page.records?.map(({ loanId }) => ({
                    type: LENDER_LOANS_HEATMAP_SERVICE_TAG,
                    id: loanId,
                  })) || [],
              ) || []),
              { type: LENDER_LOANS_HEATMAP_SERVICE_TAG, id: LIST_SERVICE_TAG },
            ]
          : [{ type: LENDER_LOANS_HEATMAP_SERVICE_TAG, id: LIST_SERVICE_TAG }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLenderLoansHeatMapInfiniteQuery } = getLenderLoansHeatMap;

